var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile2User(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "active-color-1",
    opacity: 0.4,
    d: "M7.49935 1.6665C5.31602 1.6665 3.54102 3.4415 3.54102 5.62484C3.54102 7.7665 5.21602 9.49984 7.39935 9.57484C7.46602 9.5665 7.53268 9.5665 7.58268 9.57484C7.59935 9.57484 7.60768 9.57484 7.62435 9.57484C7.63268 9.57484 7.63268 9.57484 7.64102 9.57484C9.77435 9.49984 11.4493 7.7665 11.4577 5.62484C11.4577 3.4415 9.68268 1.6665 7.49935 1.6665Z",
    fill: "#E8F0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "active-color-1",
    d: "M11.7328 11.7919C9.40781 10.2419 5.61615 10.2419 3.27448 11.7919C2.21615 12.5002 1.63281 13.4586 1.63281 14.4836C1.63281 15.5086 2.21615 16.4586 3.26615 17.1586C4.43281 17.9419 5.96615 18.3336 7.49948 18.3336C9.03281 18.3336 10.5661 17.9419 11.7328 17.1586C12.7828 16.4502 13.3661 15.5002 13.3661 14.4669C13.3578 13.4419 12.7828 12.4919 11.7328 11.7919Z",
    fill: "#E8F0FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "active-color-1",
    opacity: 0.4,
    d: "M16.6578 6.11659C16.7911 7.73325 15.6411 9.14992 14.0495 9.34159C14.0411 9.34159 14.0411 9.34159 14.0328 9.34159H14.0078C13.9578 9.34159 13.9078 9.34159 13.8661 9.35825C13.0578 9.39992 12.3161 9.14159 11.7578 8.66659C12.6161 7.89992 13.1078 6.74992 13.0078 5.49992C12.9495 4.82492 12.7161 4.20825 12.3661 3.68325C12.6828 3.52492 13.0495 3.42492 13.4245 3.39159C15.0578 3.24992 16.5161 4.46659 16.6578 6.11659Z",
    fill: "#E8F0FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "active-color-1",
    d: "M18.3249 13.8252C18.2582 14.6335 17.7415 15.3335 16.8749 15.8085C16.0415 16.2668 14.9915 16.4835 13.9499 16.4585C14.5499 15.9168 14.8999 15.2418 14.9665 14.5252C15.0499 13.4918 14.5582 12.5002 13.5749 11.7085C13.0165 11.2668 12.3665 10.9168 11.6582 10.6585C13.4999 10.1252 15.8165 10.4835 17.2415 11.6335C18.0082 12.2502 18.3999 13.0252 18.3249 13.8252Z",
    fill: "#E8F0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile2User);
export default __webpack_public_path__ + "static/media/profile-2user.f58c2f0a6526e8890783ed2bbb98de06.svg";
export { ForwardRef as ReactComponent };